<template>
	<div class="dashboard">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Order Item Report</h1>
		<div class="content-wrapper">
			<b-field label="Select Shop (optional)">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<!-- <b-field label="Select Brand (optional)">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field> -->

			<div class="single-text-wrapper">
				<b-field label="BD Code">
					<b-input v-model="bdcode" placeholder="BD Code" @keyup.native.enter="getSyncChanges()"></b-input>
				</b-field>
			</div>

			<div class="single-text-wrapper">
				<b-field label="Product ID">
					<b-input v-model="productID" placeholder="Product ID" @keyup.native.enter="getSyncChanges()"></b-input>
				</b-field>
			</div>

			<div class="datepickerWrapper">
				<b-field label="Starting Date">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startingDate" icon="calendar-today">
						<button class="button is-primary" @click="startingDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="startingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>

				<b-field label="Ending Date">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="endingDate"
						icon="calendar-today"
						:min-date="minDate"
						:max-date="maxDate"
					>
						<button class="button is-danger" @click="endingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>
			</div>

			<div class="filter-button-wrapper">
				<div class="big-button" @click="submit">SUBMIT</div>
			</div>
		</div>

		<div class="total-sales" v-if="totalSales !== null">
			<div class="total-wrapper">
				<div class="total-amount"><span>Total Quantity</span><br />{{ totalSales.qty }}</div>

				<div class="total-orders"><span>Total Orders</span><br />{{ totalSales.order_items.length }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Dashboard',
	data: () => ({
		isLoading: false,
		totalSales: null,
		startingDate: null,
		endingDate: null,
		minDate: null,
		maxDate: null,
		shops: [], // For list of shops from API
		shopsSuggestions: '', // For dropdown selection
		selectedShop: null, // Selected shop
		brands: [], // To store brands
		selectedBrand: null,
		brandSuggestions: '',
		bdcode: null,
		productID: null
	}),

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				// this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getShops()

		await this.getBrands()
	},

	computed: {
		getTotalProfit() {
			const totalProfit = this.totalSales.total_price - this.totalSales.original_total_price

			return totalProfit.toLocaleString('en-GB')
		},

		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 2000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		submit: async function() {
			if (this.startingDate == null || this.endingDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Starting and ending dates are required'
				})

				return
			}

			this.isLoading = true

			var data = {}
			const createdAt = {}

			if (this.startingDate !== null) {
				createdAt['$gte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.endingDate !== null) {
				createdAt['$lte'] = this.$moment(this.endingDate)
					.set({ hour: 24 })
					.format('x')
			}

			// For getting total value of sales
			data = {
				time: {
					createdAt
				}
			}

			if (this.bdcode) {
				let product = await this.$api.getProductDetail({ data: { bd_code: this.bdcode } })
				let productID = product.data._id

				if (product) {
					data.order_items = {
						product: productID
					}
				}
			}

			if (this.productID) {
				data.order_items = {
					product: this.productID
				}
			}

			if (this.selectedShop && this.selectedShop._id) {
				data.shop = this.selectedShop._id
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.order_items = { brand: this.selectedBrand._id }
			}

			const apiGetOrderItemReport = await this.$api.orderItemReport({ data })

			if (apiGetOrderItemReport !== undefined && apiGetOrderItemReport.data.count > 0) {
				this.totalSales = apiGetOrderItemReport.data.list[0]
				// console.log(apiGetSales)
			} else {
				this.$swal.fire('Sorry, no record found')
				this.totalSales = null
			}
			this.isLoading = false
		},

		getSales: async function() {
			const data = {}

			const apiGetSales = await this.$api.getSales({ data })
			if (apiGetSales !== undefined) {
				this.totalSales = apiGetSales.data[0]
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
